import {
  GreyGrey30,
  IconPlus,
  IndigoIndigo60,
  Primary13SemiBold,
  Tooltip,
  Box,
  Flex
} from '@sequencehq/core-components'
import { Section } from 'modules/Cube/view/common/atomic/Section'
import { Phase } from 'Cube/view/common/widgets/Pricing/Phase/Phase'
import { usePricingWidget } from 'Cube/view/common/widgets/Pricing/usePricingWidget'

export const PricingWidget = (props: {
  wideLayout?: boolean
  'data-testid'?: string
}) => {
  const pricingPhasesHook = usePricingWidget()

  return (
    <Section width="100%" data-testid={props['data-testid']} userSelect="none">
      {pricingPhasesHook.phases.map((phase, idx) => {
        const nextPhase = pricingPhasesHook.phases[idx + 1]
        return (
          <Phase
            key={phase.id}
            phaseId={phase.id}
            expanded={phase.expanded}
            focusDurationOnLoad={phase.focusDurationOnLoad}
            onExpand={pricingPhasesHook.updatePhaseExpanded(phase.id)}
            wideLayout={props.wideLayout}
            onInsertBefore={() => pricingPhasesHook.insertPhaseBefore(phase.id)}
            onInsertAfter={
              nextPhase
                ? () => pricingPhasesHook.insertPhaseBefore(nextPhase.id)
                : pricingPhasesHook.addPhase.handler
            }
            isNewlyInserted={phase.isNewlyInserted}
          />
        )
      })}
      <Box width="100%" height="1px" background={GreyGrey30} />

      <Flex
        onClick={pricingPhasesHook.addPhase.handler}
        data-testid="phases.addPhase"
        data-disabled={pricingPhasesHook.addPhase.disabled}
        userSelect="none"
        height="48px"
        padding="0 16px"
        alignItems="center"
        {...Primary13SemiBold}
        color={IndigoIndigo60}
        cursor={!pricingPhasesHook.addPhase.disabled ? 'pointer' : 'default'}
        opacity={pricingPhasesHook.addPhase.disabled ? 0.5 : 1}
        _hover={{
          opacity: !pricingPhasesHook.addPhase.disabled ? 0.8 : undefined
        }}
      >
        <Tooltip
          placement="top"
          label={pricingPhasesHook.addPhase.disabledReason}
          data-testid="phases.addPhase.tooltip"
        >
          <Flex gap="8px" alignItems="center">
            <IconPlus color={IndigoIndigo60} />
            Add new phase
          </Flex>
        </Tooltip>
      </Flex>
    </Section>
  )
}
